/* eslint-disable jsx-a11y/img-redundant-alt */
import React from "react";
import Layout from "../../layout";
import SettingSidebar from "../../components/settingsidebar";
import Emails from "./feature/Emails";

const FallbackEmail = () => {
  return (
    <>
      <Layout>
        <section className="setting_page d_flx align_top">
          <SettingSidebar />
          <Emails />
        </section>
      </Layout>
    </>
  );
};
export default FallbackEmail;
